import { useCallback } from "react"

export const useDocumentTitle = () => {
    const setDocumentTitle = useCallback((title?: string) => {
        if (!title || title.trim() == "") {
            console.warn("Unable to set title, title can't be empty");
            return;
        }

        document.title = title;
    }, [])

    const setDefaultDocumentTitle = useCallback(() => {
        setDocumentTitle("Akira");
    }, []);

    return {
        setDocumentTitle,
        setDefaultDocumentTitle
    }
}